import env from '@eneco/common/env';

export const getDataLayerEnvironment = () => {
  // isApp is based on capacitor's internal util (getPlatformId)
  // https://github.com/ionic-team/capacitor/blob/12c6294b9eb82976b1322f00da9ba5a6004f7977/core/src/util.ts#L28-L38
  const isApp = typeof window !== 'undefined' && (!!window.androidBridge || window.webkit?.messageHandlers?.bridge);
  const target = isApp ? 'app' : 'web';
  const dpxEnvironment = env('ENVIRONMENT') || 'development';
  const container = env('CONTAINER') || 'local';
  return [target, dpxEnvironment, container].join('-');
};
